import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useAuth } from './authContext';
import { aiQuizService } from '../services/aiQuizService';

const AIQuizUsageContext = createContext(null);

export function AIQuizUsageProvider({ children }) {
  const { user } = useAuth();
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(false);

  const refreshUsage = useCallback(async () => {
    if (!['student', 'preper'].includes(user?.user_type)) {
      setUsage(null);
      return null;
    }
    setLoading(true);
    try {
      console.log('this was triggered')
      const data = await aiQuizService.getUsage();
      console.log('AI quiz usage data:', data);
      setUsage(data);
      return data;
    } catch (error) {
      console.error('Failed to fetch AI quiz usage:', error);
      return null;
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refreshUsage();
  }, [refreshUsage]);

  const value = useMemo(() => ({ usage, loading, refreshUsage }), [usage, loading, refreshUsage]);
  return <AIQuizUsageContext.Provider value={value}>{children}</AIQuizUsageContext.Provider>;
}

export function useAIQuizUsage() {
  const context = useContext(AIQuizUsageContext);
  if (!context) throw new Error('useAIQuizUsage must be used within AIQuizUsageProvider');
  return context;
}
